import { Badge, Tabs, withStyles } from '@material-ui/core';
import { orange } from '../../core/theme';
import React from 'react';

export interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div style={{ overflow: 'hidden' }} hidden={value !== index} {...other}>
      {children as any}
    </div>
  );
}

export const WhiteTabs: any = withStyles({
  indicator: {
    backgroundColor: 'white',
  },
})(Tabs);

export const whiteTabStyle = { color: 'white', minWidth: 70 };
export const tabIconStyle: any = { ...whiteTabStyle, ...{ minWidth: 18 } };

export const WhiteBadge: any = withStyles(() => ({
  badge: {
    backgroundColor: 'white',
    color: orange,
    border: 'solid 1px ' + orange,
  },
}))(Badge);
